<template>
  <div>
    <el-dialog :title="detailTitle" :visible.sync="leaveAuditDia.flag" :close-on-click-modal="false"
      :close-on-press-escape="false" distroy-on-close @close="closeFrom">
      <div>
        <el-form :model="ruleForm" ref="rForm" label-width="100px" class="ruleForm" :rules="rules">
          <el-form-item label="审核意见：" prop="auditSchedule">
            <el-radio-group v-model="ruleForm.auditSchedule" @input="auditScheduleChange">
              <el-radio v-for="(item, i) in auditScheduleAttr" :key="i" :label="item.paramKey">
                {{ item.paramValue }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.auditSchedule === '3'" label="转交人：" prop="auditUserId">
            <el-input v-model="ruleForm.auditUserId" v-show="false"></el-input>
            <el-input style="width: 30%" placeholder="请选择转交人" v-model="ruleForm.auditUserName" readonly></el-input>
            <el-button class="button-dept" @click="selectAuditor">选择</el-button>
          </el-form-item>
          <el-form-item label="驳回原因：" prop="auditContent" v-if="ruleForm.auditSchedule === '1'"
            :rules="[{ required: false, message: '请输入驳回原因' }]">
            <el-input type="textarea" placeholder="请输入驳回原因" :row="3" v-model="ruleForm.auditContent" :maxlength="200"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="意见说明：" prop="auditContent" v-if="ruleForm.auditSchedule === '3'">
            <el-input type="textarea" placeholder="请输入意见说明" :row="3" v-model="ruleForm.auditContent"></el-input>
          </el-form-item>
          <el-form-item label="短信通知：" prop="isNotice" :rules="[{ required: true, message: '请选择短信通知' }]">
            <el-radio-group v-model="ruleForm.isNotice" @change="isNoticeChange">
              <el-radio v-for="(item, i) in isNoticeAttr" :key="i" :label="item.paramKey">
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="isSend">
            <el-form-item label="发送对象：" v-if="ruleForm.auditSchedule === '2'" prop="smsSendTypes">
              <el-checkbox-group v-model="ruleForm.smsSendTypes" @change="changeSmsSendTypes">
                <el-checkbox v-for="item in smsList" :label="item.sendType" :key="item.sendType">{{ item.sendTypeName
                  }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div v-for="smsItem in filterSmsList" :key="smsItem.sendType">
              <el-form-item :label="(ruleForm.auditSchedule === '2' ? smsItem.sendTypeName : '发送对象') + '：'">
                <div>{{ smsItem.userName }}</div>
              </el-form-item>
              <el-form-item label="消息内容：">
                <el-input v-model="smsItem.content" :disabled="true" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 3 }"></el-input>
              </el-form-item>
            </div>

          </div>

          <el-row v-if="thisItem.leaveType === 3 && thisItem.auditStatus === 4">
            <el-col>
              <el-form-item label="温馨提示：">
                <div>
                  <div>
                    1、该学员可能存在请假行为，请提醒联络员另行提交请假申请。
                  </div>
                  <div>
                    2、退学撤销后，学员结业状态会更新为“未结业”，如有需要请至学员管理列表手动调整。
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <butn @click.native="closeFrom()" btntype title="取消"></butn>
        <butn btntype="primary" @click.native="updateForm()" title="确定"></butn>
      </div>
    </el-dialog>
    <Auditor :dialogVisible="dialogVisible" @didSelectAuditor="didSelectAuditor" v-if="dialogVisible.flag"
      :deptId="auditApplyId" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { auditHistoryUpdate, getSmsContentNew } from "@/api/leaveAudit";
import { getDataMap } from "@/api/sysParam";
import Auditor from "./auditor";
import { setItem } from "@/utils/storage.js";

export default {
  components: {
    Auditor,
    butn,
  },
  props: {
    leaveAuditDia: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    uuid: {
      type: String,
      default: () => "",
    },
    thisItem: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      size: "small",
      isNoticeAttr: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true },
      ],
      ruleForm: {
        auditUserId: "",
        auditUserName: "",
        auditSchedule: "2",
        auditContent: "",
        isNotice: true,
        auditAttachment: null,
        attachmentList: [],
        smsSendTypes: []
      },
      auditApplyId: "",
      deptId: "",
      detailTitle: "审核",
      auditScheduleAttr: [],
      rules: {
        auditSchedule: [{ required: true, message: "请选择审核意见" }],
        auditUserId: [
          { required: true, message: "请选择转交人", trigger: "change" },
        ],
        smsSendTypes: [{ required: true, message: '请选择发送对象' }]
      },
      isSend: true,
      dialogVisible: {
        flag: false,
      },
      smsList: [],
      filterSmsList: [],
    };
  },
  methods: {
    // 获取短信模版
    getSmsTemplate() {
      let params = {
        auditApplyId: this.auditApplyId,
        auditContent: '', // 审核意见
        leaveDays: this.thisItem.duration, // 请假天数
        leaveType: this.thisItem.leaveType, // 请假类型
        leaveStartTime: this.thisItem.leaveStartTimeName, // 请假开始时间
        auditNotes: this.thisItem.auditNotes, // 申请事由
        unitPosition: this.thisItem.unitPosition, // 单位及职务
        className: this.thisItem.className, // 班级名称
        auditSchedule: this.handleAuditSchedule(),
        userName: this.thisItem.userName, // 用户名称
        userUuid: this.thisItem.userUuid,
        createUserName: this.thisItem.createUserName,
        createUserId: this.thisItem.createUserId,
        leaveEndTime: this.thisItem.leaveEndTimeName, // 请假截止时间 (yyyy-MM-dd HH)
        classId: this.thisItem.bizId,
      };
      getSmsContentNew(params).then((res) => {
        if (res.code !== 0) return;
        const { data = [] } = res;
        let list = data.map((item) => {
          let newItem = { ...item }
          if (this.ruleForm.auditSchedule === '3' && this.ruleForm.auditUserId.length > 0) {
            return {
              ...newItem,
              userId: this.ruleForm.auditUserId,
              userName: this.ruleForm.auditUserName,
            }
          }
          if (item.sendType == 3) {
            return {
              ...newItem,
              userName: item.multiUser.map((user) => user.userName).join('，')
            }
          }
          return newItem
        });
        this.smsList = [...list];
        this.filterSmsList = [...list]
        this.ruleForm.smsSendTypes = list.map((item) => item.sendType) || []
      });
    },

    changeSmsSendTypes() {
      this.filterSmsList = this.smsList.filter(item =>
        this.ruleForm.smsSendTypes.includes(item.sendType)
      );
    },

    // 处理短信模版审核进度入参
    handleAuditSchedule() {
      let auditSchedule;
      // 审核进度(0送审 1不同意 2同意 3继续流转 4已撤销 5发起撤销 6撤销不通过 7撤销通过 8撤销流转)
      if (this.thisItem.auditStatus == 4) {
        if (this.ruleForm.auditSchedule == 1) {
          auditSchedule = 6;
        } else if (this.ruleForm.auditSchedule == 2) {
          auditSchedule = 7;
        } else auditSchedule = 8;
      }
      if (this.thisItem.auditStatus == 0) {
        auditSchedule = this.ruleForm.auditSchedule;
      }
      return auditSchedule;
    },
    // 切换审核意见
    auditScheduleChange(val) {
      if (!!val) {
        this.getSmsTemplate();
      }
      this.$refs["rForm"].clearValidate();
    },
    // 选择短信通知
    isNoticeChange() {
      if (this.ruleForm.isNotice) {
        this.isSend = true;
      } else {
        this.isSend = false;
      }
    },
    // 获取数据字典: 审核状态
    getSysParam(param) {
      getDataMap(param).then((res) => {
        if (res.code !== 0) return;
        if (param === "AUDIT_SCHEDULE") {
          let temp = res.data.slice(1, 4);
          temp[2] = { paramKey: "3", paramValue: "转交" };
          this.auditScheduleAttr = temp;
        }
      });
    },
    // 关闭审核弹窗
    closeFrom() {
      // 点击取消 数据重置
      this.ruleForm.auditUserName = "";
      this.ruleForm.auditUserId = "";
      this.$refs["rForm"].resetFields();
      this.$emit("closeAuditDia");
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          let tempFile = {};
          if (
            this.ruleForm.attachmentList &&
            this.ruleForm.attachmentList.length > 0
          ) {
            tempFile = {
              auditAttachment: JSON.stringify(this.ruleForm.attachmentList),
            };
          }
          let smsList = [];
          // 组装数据
          if (this.ruleForm.isNotice) {
            this.filterSmsList.forEach(item => {
              let userIds = []
              if (item.multiUser && item.multiUser.length > 0) {
                userIds = item.multiUser.map(item => item.userId)
              } else {
                userIds = [item.userId];
              }
              let content = item.content;
              if (item.content.indexOf("{驳回原因}") > -1) {
                let flag = this.ruleForm.auditContent && this.ruleForm.auditContent.length > 0;
                content = content.replace("{驳回原因}", flag ? `原因为：${this.ruleForm.auditContent}，` : '');
              }
              smsList.push({ userIds, content });
            });
          }
          let params = Object.assign({
            auditApplyId: this.auditApplyId,
            uuid: this.uuid,
            smsList,
          }, {
            ...this.ruleForm, ...tempFile
          })
          delete params.smsSendTypes;
          auditHistoryUpdate(params).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.CUFlag = false;
              this.$emit("updateAuditDetail");
              setItem(this.REFRESH_FLAG, true);
              this.$router.back();
            }
          });
          this.closeFrom();
        }
      });
    },
    // 选择流转人弹窗
    selectAuditor() {
      this.dialogVisible.flag = true;
    },
    // 关闭-选择流转人弹窗
    closeDialog() {
      this.dialogVisible.flag = false;
    },
    // 选择转交人
    didSelectAuditor(auditor) {
      this.dialogVisible.flag = false;
      if (this.filterSmsList && this.filterSmsList.length) {
        this.filterSmsList = this.filterSmsList.map(item => {
          return {
            ...item,
            userId: auditor.uuid,
            userName: auditor.userName
          }
        })
      }
      this.ruleForm.auditUserId = auditor.uuid;
      this.ruleForm.auditUserName = auditor.userName;
    },
  },
  created() {
    this.getSysParam("AUDIT_SCHEDULE");
    this.auditApplyId = this.thisItem.uuid;
    this.deptId = this.thisItem.deptId;
    /** 
     * 1、请假审核通过，可发送短信给提交人和学员本人
    2、请假审核不通过、退学审核通过/不通过、撤销请假、撤销退学，可发送短信给提交人，学员不可选择
    请假类型 leaveType(0:病假, 1:事假, 2:公假, 3:退学);
    审核状态 auditStatus(0:审核中, 4:撤销审核中)
    */
    // 调短信模版接口
    this.getSmsTemplate();
  },
};
</script>

<style lang="scss" scoped>
.button-dept {
  margin-left: 10px;
}

/deep/ .el-form-item {
  margin-bottom: 16px
}
</style>
